import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export default function Loading() {
    return (_jsx(_Fragment, { children: "loading..." }));
}
;
